import { Suspense } from "react";

import AlertProvider from "@hl/base-components/lib/alert/AlertProvider";
import { AuthProvider } from "@hl/shared-features/lib/features/auth";
import { AppBootstrap } from "@hl/shared-features/lib/features/auth/AppBootstrap";
import TransactionProvider from "@hl/shared-features/lib/features/evm-tx/TransactionProvider";
import MarketplaceProvider from "@hl/shared-features/lib/features/marketplace/provider";
import { ModalStack } from "@hl/shared-features/lib/features/modal";
import { HighlightWebsocket } from "@hl/shared-features/lib/features/websocket/HighlightWebsocket";
import { NotificationsProvider } from "@mantine/notifications";

import Root from "./components/layout/Root";
import { Routes } from "./routes";

export const App = () => {
  return (
    <Suspense fallback={""}>
      <AuthProvider>
        <AppBootstrap>
          <AlertProvider>
            <HighlightWebsocket>
              <NotificationsProvider
                position="bottom-right"
                containerWidth={287}
              >
                <TransactionProvider>
                  <MarketplaceProvider>
                    <ModalStack>
                      <Root>
                        <Routes />
                      </Root>
                    </ModalStack>
                  </MarketplaceProvider>
                </TransactionProvider>
              </NotificationsProvider>
            </HighlightWebsocket>
          </AlertProvider>
        </AppBootstrap>
      </AuthProvider>
    </Suspense>
  );
};
